/**
 * 사용자 접근 이력
 */
const ACCESS_HIST = {
  /**
   * 로그인/로그아웃 이력 - 실패 사유
   *
   * @type {Object}}
   */
  loginFailLog: {
    WRONG_INPUT: '아이디 혹은 비밀번호를 잘못 입력하였습니다.',
    LOCKED_ACCOUNT: '잠금 상태인 계정입니다.',
    INACTIVE_ACCOUNT: '삭제된 계정입니다.',
    DISALLOWED_IP: '접근이 허용되지 않은 IP입니다.',
  },
};

export default ACCESS_HIST;



// WEBPACK FOOTER //
// ./src/constants/access-hist.js